import React from 'react';
import PageContent from './Content';


const SuccessPage =  ({ data, setComponent }) => {
    
    const orderId = data.orderId;

    return (

        <div className="container m-5">

            <h1>הזמנתך נקלטה בהצלחה</h1>
            <h4 className='text-center'>מספר הזמנה: {orderId}</h4>
            <PageContent furl='אישור-הזמנה' />

        </div>
    );

};

export default SuccessPage;
